module.exports = __webpack_public_path__ + "static/font-26951704a6672167c704c0a84029d75b.ttf";